import {
  cancelPendingLogoutConfirmation,
  desktopLogoutConfirmationAtom,
  registerActiveDesktopCaptureDetector,
  resolveLogoutConfirmation,
} from '@/lib/desktopLogoutConfirmation';
import { logger } from '@/utils/logger/logger';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import { detectActiveDesktopCapture } from './activeDesktopCapture';

const DesktopLogoutConfirmationImplementation = dynamic(
  () =>
    import('./desktop-logout-confirmation-implementation')
      .then((module) => module.DesktopLogoutConfirmationImplementation)
      .catch((error: unknown) => {
        logger.warn('[desktopLogoutConfirmation] implementation failed to load', {
          errorName: error instanceof Error ? error.name : typeof error,
        });
        return function DesktopLogoutConfirmationLoadFailure() {
          useEffect(() => {
            // Fail open when the dialog cannot render; bounded settlement still precedes teardown.
            resolveLogoutConfirmation('failedOpen');
          }, []);
          return null;
        };
      }),
  { ssr: false, loading: () => null }
);

export function DesktopLogoutConfirmation() {
  const confirmation = useAtomValue(desktopLogoutConfirmationAtom);
  useEffect(() => {
    const unregisterDetector = registerActiveDesktopCaptureDetector(
      detectActiveDesktopCapture
    );

    return () => {
      unregisterDetector();
      cancelPendingLogoutConfirmation();
    };
  }, []);

  if (!confirmation) return null;

  return <DesktopLogoutConfirmationImplementation />;
}
